import TrashIcon from "../images/TrashIcon.mjs";

/**
 * App icon for trash (both the bin concept and the delete action)
 * @see {GlyphIcon}
 * @see {TrashIcon}
 */
const AppTrashIcon = class extends TrashIcon {}

export default AppTrashIcon;



